module.exports = __webpack_public_path__ + "static/media/logo-added-auth.bca783f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/auth/loginadded/logo/logo-added-auth.png
// module id = 825
// module chunks = 0